module.exports = __webpack_public_path__ + "static/media/seventeenth_henry_social_club1.f2cfb014.jpg";